import React from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// styled-components v6 forwards every prop to the underlying element; v5
// filtered them through is-prop-valid first. Without that filter, style-only
// props like `columns` or `maxColumns` land on the DOM as invalid attributes.
function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

// Restores the v5 default. Tests render through this too, so a component's DOM
// output in a test matches what the browser actually gets.
export const StyledComponentsProvider = ({ children }) => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
    {children}
  </StyleSheetManager>
);
